import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/GenericServices/ServiceRequestGS.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import cancelicon from '../../../Assets/TruckVisits/Assets-Desktop/cancel-icon.svg';
import quotationHistory from '../../../Assets/MarketPlace/quotationHistory.svg';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
class ServiceRequestGS extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [
                { id: 1, quotationID: "10001", serviceType: "Transportation Service", companyName: "**********", location: "Addington, 4001", requestedOn: "23-May-2021 13:15", status: "Open" },
                { id: 2, quotationID: "10002", serviceType: "Container Repair Service", companyName: "**********", location: "Pretoria, 0001", requestedOn: "23-May-2021 13:15", status: "Open" },
                { id: 3, quotationID: "10003", serviceType: "Container Repair Service", companyName: "**********", location: "Pretoria, 0001", requestedOn: "22-May-2021 13:15", status: "Open" }
            ],
            searchRequest: "",
            searchRequestlength: 0,
            datatemporary: [],
            search: "",
            searchlength: 0,
            quotationHisTempData: [],
            errorMessage: false,
            fliterValue: 'All',
            fliterValueDropDown: false,
            cancelService: true,
            filterDataValues: [],
            showQuotationReceived: true,
            showServiceDetails: false,
            quotationHisDetails: [
                {
                    'QuotationId': '10001',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Service',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '10002',
                    'orderDate': '1613110942',
                    'serviceType': 'Container Repair Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '10003',
                    'orderDate': '1613110942',
                    'serviceType': 'Clearing & Forwarding Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '10004',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Service',
                    'Status': 'Open'
                }
            ],
        }
        this.handlechangeSearchTransportationServiceID = this.handlechangeSearchTransportationServiceID.bind(this);
        this.handlechangeSearchAppointmentNo = this.handlechangeSearchAppointmentNo.bind(this);
    }
    handlechangeSearchTransportationServiceID = (e) => {
        this.setState({
            searchRequest: e.target.value,
            searchRequestlength: e.target.value.length
        });
    };
    searchTransportationService = () => {
        if (this.state.searchRequestlength > 0) {
            const datafilter = this.state.data.filter(i => i.quotationID == this.state.searchRequest)
            this.setState({ datatemporary: datafilter });
            console.log("inside search function", this.state.datatemporary);
        }
    }
    handleRequestContainer = event => {
        this.state.datatemporary.find((dataStorage) => {
            if (dataStorage.id === event + 1) {
                this.props.history.push('/');
            }
        })
    }
    filterDataValues = [{ name: "All" }, { name: "Open" }, { name: "Closed" }, { name: "Rejected" }]
    componentDidMount = () => {
    }
    handleDetails = (index) => {
        this.state.quotationHisTempData.find((truckdataStore) => {
            if (truckdataStore.QuotationId === this.state.quotationHisTempData[index].QuotationId) {
                //
            }
        })
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ fliterValueDropDown: false });
        }
    };
    toggleDropdownCargoPackaging = () => {
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
    };
    changeFilterValue = (event) => {
        const found = this.filterDataValues.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ fliterValue: found.name });
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
        if (found.name == 'Open') {
            const openFilter = this.state.quotationHisDetails.filter(i => i.Status == 'Open')
            console.log('abc--', openFilter)
            this.setState({
                quotationHisTempData: openFilter
            })
        } else if (found.name == 'Closed') {
            const closedFilter = this.state.quotationHisDetails.filter(i => i.Status == 'Closed')
            console.log('abc----', closedFilter)
            this.setState({
                quotationHisTempData: closedFilter
            })
        } else if (found.name == 'Rejected') {
            const rejectedFilter = this.state.quotationHisDetails.filter(i => i.Status == 'Rejected')
            console.log('abc----', rejectedFilter)
            this.setState({
                quotationHisTempData: rejectedFilter
            })
        }
        else {
            this.setState({
                quotationHisTempData: this.state.quotationHisDetails
            })
        }
    }
    handlechangeSearchAppointmentNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length,
            errorMessage: false
        });
    };
    showQuotationReceivedfunction = () => {
        this.setState({ showQuotationReceived: true, showServiceDetails: false });
    }
    showServiceDetailsfunction = () => {
        this.setState({ showQuotationReceived: false, showServiceDetails: true });
    }
    searchByOrderId = () => {
        if (this.state.searchlength > 0) {
            const truckdatafilter = this.state.quotationHisDetails.filter(i => i.QuotationId == this.state.search)
            console.log('a---', truckdatafilter);
            this.setState({ quotationHisTempData: truckdatafilter });
            if (truckdatafilter.length === 0) {
                this.setState({ errorMessage: true });
            }
            else {
                this.setState({ errorMessage: false });
            }
            console.log("inside search function", this.state.quotationHisTempData);
        }
    }
    cancelServiceFunction = () => {
        this.setState({ cancelService: !this.state.cancelService })
    }
    render() {
        // myRequest search
        if (this.state.searchRequestlength == 0) {
            this.state.datatemporary = this.state.data;
            console.log("inside render search", this.state.datatemporary);
        }
        // QuotationHistory search
        if (this.state.searchlength == 0 && this.state.fliterValue === 'All') {
            this.state.quotationHisTempData = this.state.quotationHisDetails;
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.ServiceRequestGSTitle} description={TitleDescription.ServiceRequestGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Service Requests</small>
                            </div>
                            {this.state.showQuotationReceived &&
                                <div id="ServiceRequestAcceptMobile" className="ServiceRequestNavbarNameRight">
                                    <a><img src={quotationHistory} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                        <small
                                            class={this.state.cancelService ? "ServiceRequestNavbarRightText" : "ServiceRequestNavbarGrayRightText"}
                                            onClick={this.cancelServiceFunction}>
                                            My Services
                                        </small>
                                    </a>
                                </div>
                            }
                        </nav>
                        <hr class="hr1" />
                        <div class="topPartButtonSectionServiceRequestDiv">
                            <div class="topPartInnerButtonSectionTransportationServiceDiv">
                                <div class={this.state.showQuotationReceived ? "ButtonDivRedBorderTransportationService" : "ButtonDivTransportationService"} onClick={this.showQuotationReceivedfunction}>
                                    <small class={this.state.showQuotationReceived ? "buttonNameBlackTransportationService" : "buttonNameRedTransportationService"}>Request History</small>
                                </div>
                                <div class={this.state.showServiceDetails ? "ButtonDivRedBorderTransportationService" : "ButtonDivTransportationService"} onClick={this.showServiceDetailsfunction}>
                                    <small class={this.state.showServiceDetails ? "buttonNameBlackTransportationService" : "buttonNameRedTransportationService"}>My Requests</small>
                                </div>
                            </div>
                        </div>
                        {this.state.showQuotationReceived && <>
                            <nav class="ServiceRequestMobileNavbar">
                                <div className="ServiceRequestNavbarNameRight">
                                    <a><img src={quotationHistory} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                        <small
                                            class={this.state.cancelService ? "ServiceRequestNavbarRightText" : "ServiceRequestNavbarGrayRightText"}
                                            onClick={this.cancelServiceFunction}>
                                            My Services
                                        </small>
                                    </a>
                                </div>
                            </nav>
                            <hr class="hrSRMobile" />
                        </>}
                        <div class={this.state.showQuotationReceived ? "ServiceRequestMainCard" : "ServiceRequestMyRequestMainCard"}>
                            {this.state.showQuotationReceived ?
                                <div>
                                    <div class="QuotationHisSearchUprDiv">
                                        <div class="QuotationHisSearchDiv">
                                            <input
                                                className="appointmentSearch"
                                                placeholder="Search by  Service Request ID"
                                                autoComplete="off"
                                                id="quotationHisDropDownCss"
                                                onChange={this.handlechangeSearchAppointmentNo}
                                                value={this.state.search}
                                            ></input>
                                            <img onClick={this.searchByOrderId} id="QuotationFilter_imgDrop" src={searchimg} width="16" height="16" />
                                        </div>
                                        <div class="QuotationFilterDiv">
                                            <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                                <Input
                                                    readOnly name="CargoPackaging" class="input" placeholder=""
                                                    type="text" id="quotationHisDropDownCss" value={this.state.fliterValue}
                                                />
                                                <i id="Quotation_imgDrop" onClick={this.toggleDropdownCargoPackaging}>
                                                    {this.state.fliterValueDropDown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                </i>
                                            </div>
                                            {this.state.fliterValueDropDown && (
                                                <div class="CrtTptReqestDropDowmDiv" >
                                                    <div class="CrtTptReqestDropCard" ref={this.container} >
                                                        {(this.filterDataValues.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(val) => this.changeFilterValue(val)} id="CrtTptReqestDropRowSize">
                                                                    <small class="" id="CrtTptReqestDropRowText" >{name.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div id="QuotationHisTopDiv">
                                        {!this.state.errorMessage ?
                                            (this.state.quotationHisTempData.map((name, index) => {
                                                return (
                                                    <div class="QuotationHisMainCardDiv" onClick={() => this.handleDetails(index)}>
                                                        <div class="QuotationHisDivRow" >
                                                            <div class="QuotationHisMainColumn1">
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv1'>
                                                                    <small id="QuotationHisLable"> Service Request ID</small>
                                                                    <small id='QuotationHisValue'>{name.QuotationId}</small>
                                                                </div>
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv2'>
                                                                    <small id="QuotationHisLable"> Service Request Date & Time</small>
                                                                    <small id='QuotationHisValue'>{FormatTimeStamp(name.orderDate).timedateToLocale}</small>
                                                                </div>
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv3'>
                                                                    <small id="QuotationHisLable">Service Type</small>
                                                                    <small id='QuotationHisValue'>{name.serviceType}</small>
                                                                </div>
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv4'>
                                                                    <small id="QuotationHisLable">Status</small>
                                                                    <small id={name.Status == 'Open' ? 'QuotationHisValueGreen' : "QuotationHisValue"}>{name.Status}</small>
                                                                </div>
                                                            </div>
                                                            <div class="QuotationHisArrow" >
                                                                <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }))
                                            :
                                            <div class="NoQuotationHistory">
                                                <small id="nodatamessage1">No result found</small>
                                            </div>
                                        }
                                    </div>
                                </div>
                                :
                                // second button content
                                <div>
                                    <div class="conCsDivLow199TransportationService">
                                        <div class="csDivLow2Pre1TransportationService">
                                            <input
                                                className="preSearchTransportationService"
                                                placeholder="Search by  Service Request ID"
                                                autoComplete="off"
                                                id="secrchInput1Pre11TransportationService"
                                                onChange={this.handlechangeSearchTransportationServiceID}
                                                value={this.state.searchRequest}
                                            ></input>
                                            <img onClick={this.searchTransportationService} id="searchPre_Img12TransportationService" src={searchimg} width="16" height="16" />
                                        </div>
                                        <div class="ServiceRequestFilterContainerDiv">
                                            <a><small class="ServiceRequestFilterValue">Filter Requests</small>
                                                <img src={cancelicon} class="ml-2" id="ServiceRequestFilterImg" alt="" loading="lazy" />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="consDiv1TransportationService">
                                        {(this.state.datatemporary.map((datatemporary, index) => {
                                            return (
                                                <div class="outDivInsideTransportationService" onClick={() => this.handleRequestContainer(index)}>
                                                    <div class="secondDivvTransportationService">
                                                        <div class="outerTransportationServiceWholeDataDiv">
                                                            <div class="TransportationServiceWholeDataWithArrowDiv">
                                                                <div class="TransportationServiceWholeDataDiv">
                                                                    <div class="ServiceRequestRow1Div">
                                                                        <div class="ServiceRequestContent0Div">
                                                                            <small id="QuotationHisLable"> Service Request ID</small>
                                                                            <small id="QuotationHisValue">{datatemporary.quotationID}</small>
                                                                        </div>
                                                                        <div class="ServiceRequestContent1Div">
                                                                            <small id="QuotationHisLable">Service Type</small>
                                                                            <small id="QuotationHisValue">{datatemporary.serviceType}</small>
                                                                        </div>
                                                                        <div class="ServiceRequestContent2Div">
                                                                            <small id="QuotationHisLable">Company Name</small>
                                                                            <small id="QuotationHisValue">{datatemporary.companyName}</small>
                                                                        </div>
                                                                        <div class="ServiceRequestContent3Div">
                                                                            <small id="QuotationHisLable">Location</small>
                                                                            <small id="QuotationHisValue">{datatemporary.location}</small>
                                                                        </div>
                                                                    </div>
                                                                    <div class="TransportationServiceRow2Div">
                                                                        <div class="ServiceRequestContent0Div">
                                                                            <small id="QuotationHisLable">Requested On</small>
                                                                            <small id="QuotationHisValue">{datatemporary.requestedOn}</small>
                                                                        </div>
                                                                        <div class="ServiceRequestContent1Div">
                                                                            <small id="QuotationHisLable">Status</small>
                                                                            <small class={datatemporary.status === "Open" || datatemporary.status === "Accepted" ? "TransportationServiceValueGreen" : "TransportationServiceValueRed"}>{datatemporary.status}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="rightOut1DivTransportationService">
                                                                    <img src={rightarrow} id="rightArrowImgTransportationService" height="16" width="16" class="" alt="" loading="lazy" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>);
                                        }))}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="ServiceRequestFooter1">
                    <Footer />
                </div>
                <div class="ServiceRequestFooter2">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default ServiceRequestGS;